import { useToast } from 'hephaestus/web';
import { useEffect } from 'react';

export type UseBlockingToastProp = {
  isActive: boolean;
  message: string;
  variant: 'error' | 'warning';
};

// autoClose is off because the toast explains a blocked Continue, which outlives the default timeout.
export const useBlockingToast = ({
  isActive,
  message,
  variant,
}: UseBlockingToastProp) => {
  const { enqueueToast, closeToast } = useToast();

  useEffect(() => {
    if (!isActive) return;

    const toastId = enqueueToast(message, { variant, autoClose: false });

    return () => closeToast(toastId);
  }, [isActive, message, variant, enqueueToast, closeToast]);
};
